import { Link } from '@tanstack/react-router';
import { NAV_ITEMS } from './navItems';
import { SlidingIndicator } from './SlidingIndicator';
import styles from './PhoneTabBar.module.css';

const TAB_LABELS = NAV_ITEMS.map(({ label, Icon }) => <><Icon size={20} aria-hidden="true" />{label}</>);

export function PhoneTabBar() {
  return (
    <nav className={styles.bar} aria-label="Tabs">
      <SlidingIndicator variant="underline" labels={TAB_LABELS} labelClassName={styles.tab} />
      {NAV_ITEMS.map(({ to, exact }, i) => (
        <Link key={to} to={to} className={styles.tab} activeOptions={{ exact }}>{TAB_LABELS[i]}</Link>
      ))}
    </nav>
  );
}
